<template>
  <tr class="pt-message-table-item">
       <td>{{label}}：</td>
       <td><slot/></td>
  </tr>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-message-table-item'

export default {
  name: 'pt-message-table-item',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    tdMaxWidth: {
      type: [Number, String],
      default: 0
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var";
.pt-message-table-item{
      >td{
            line-height: 30px;
            font-size: 14px;
        }
        >:first-child{
            display: flex;
            color:@mainColor;
            justify-content: flex-end;
            white-space:nowrap
        }
        >:last-child{
            color: #000
        }
}
</style>
